import { observer } from 'mobx-react-lite';
import { DefaultButton, IconButton } from '@fluentui/react/lib/Button';
import SurfaceTimestrip from './SurfaceTimestrip';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { logUsage } from 'owa-analytics';
import ChevronDownRegular from 'owa-fluent-icons-svg/lib/icons/ChevronDownRegular';
import ChevronLeftRegular from 'owa-fluent-icons-svg/lib/icons/ChevronLeftRegular';
import ChevronRightRegular from 'owa-fluent-icons-svg/lib/icons/ChevronRightRegular';
import ChevronUpRegular from 'owa-fluent-icons-svg/lib/icons/ChevronUpRegular';
import loc from 'owa-localize';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import {
    goToToday,
    goToNextSurfaceDateRange,
    goToPreviousSurfaceDateRange,
} from 'owa-calendar-module-commanding';
import { todayStringLowerCaseText } from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import {
    getPreviousLabel,
    getNextLabel,
    getTodayLabel,
} from '../utils/getSurfaceNavigationStrings';
import * as React from 'react';

import styles from './CalendarModuleNavigationBar.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export default observer(function CalendarModuleNavigationBar() {
    const goToTodayLabel = getTodayLabel();
    const currentDateRangeType = getSurfaceStore().dateRangeType;
    const previousLabel = getPreviousLabel(currentDateRangeType);
    const nextLabel = getNextLabel(currentDateRangeType);

    const onPrevious = () => {
        logUsage('SurfaceCommandBar_Previous', {
            currentDateRangeType: currentDateRangeType,
        });
        goToPreviousSurfaceDateRange();
    };

    const onNext = () => {
        logUsage('SurfaceCommandBar_Next', {
            currentDateRangeType: currentDateRangeType,
        });
        goToNextSurfaceDateRange();
    };

    const isMonthDateRange = currentDateRangeType === DateRangeType.Month;

    return (
        <div className={styles.navigationBar}>
            <DefaultButton
                className={styles.todayButton}
                onClick={goToToday}
                text={loc(todayStringLowerCaseText)}
                ariaLabel={goToTodayLabel}
                title={goToTodayLabel}
                styles={{
                    label: styles.viewMenuButtonLabel,
                }}
            />
            <IconButton
                iconProps={{
                    iconName: isMonthDateRange ? ChevronUpRegular : ChevronLeftRegular,
                }}
                onClick={onPrevious}
                aria-label={previousLabel}
                title={previousLabel}
                className={classNames(styles.navigationBarIcon, 'flipForRtl')}
            />
            <IconButton
                iconProps={{
                    iconName: isMonthDateRange ? ChevronDownRegular : ChevronRightRegular,
                }}
                onClick={onNext}
                aria-label={nextLabel}
                title={nextLabel}
                className={classNames(styles.navigationBarIcon, 'flipForRtl')}
            />
            <SurfaceTimestrip />
        </div>
    );
});
